import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';

import { MatDialog } from '@angular/material';
import { ResultDialogComponent } from '../result-dialog/result-dialog.component';

import { AuthGuardService, CommercialService, DialogService, LoadingService, UserService } from '@core/services';
import { Commercial, User } from '@shared/models';

import { fadeAnimation } from '../../app.animations';

@Component({
    selector: 'app-change-currency',
    templateUrl: './change-currency.component.html',
    styleUrls: ['./change-currency.component.css'],
    animations: [fadeAnimation]
})
export class ChangeCurrencyComponent implements OnInit, OnDestroy {

    currencyForm: FormGroup;
    subscription: Subscription;
    isCommercialSubscription: Subscription;
    user: User;
    commercial: any;
     programs: any;
    accountId: number;
    programTypeId: number;

    constructor(private _service: UserService,
                private _commercialService: CommercialService,
        private _authGuard: AuthGuardService,
        private _fb: FormBuilder,
        private _dialogService: DialogService,
        private dialog: MatDialog,
        private _loadingService: LoadingService,
        private _router: Router) {
    }

    ngOnInit() {
        this.currencyForm = this._fb.group({
            currency: this._fb.group({
                ProgramTypeId: new FormControl()
            })
        });
        this.subscription = this._service.getUser().subscribe(user => {
            this.user = user;
        });
        this.isCommercialSubscription = this._commercialService.getCommercialValue().subscribe(commercial => {
            this.commercial = commercial;
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.isCommercialSubscription.unsubscribe();
    }

    public updateAccountId(event) {
        this.accountId = event;
    }

    onSubmit() {
        //check if customer is commercial.
        if(this.commercialAlert()){
            return false; //cancel submit if commercial account alert is successfully launched
        }

        this.changeCurrencyType();
    }

    private async changeCurrencyType() {
      this._authGuard.authenticatedPost('portfolios/ChangeAccountCurrency', this.setUpChangeCurrencyData()).subscribe(
          result => {
              this.user.accountSummaryArray[this.user.accountIndex].ProgramType = this.programTypeId;
              let dialogRef = this.dialog.open(ResultDialogComponent, {
                  data: {
                      message: "You have successfully updated your currency",
                      alertType: 'success',
                      title: 'Updated Currency'
                  }
              });
              this._loadingService.hideLoader(); // hide loader on success
              return true;
          },
          error => {
            console.log('Change Currency Error:', error);
            this._loadingService.hideLoader(); // hide loader on error.
          }
      );
    }

    private setUpChangeCurrencyData() {
        return {
            'ProgramTypeId': this.programTypeId ? this.programTypeId : this.user.accountSummaryArray[this.user.accountIndex].ProgramType,
            'AccountId': this.user.accountSummaryArray[this.user.accountIndex].id,
            'Email': this.user.email
        };
    }

    public changed(event) {
        console.log(event);
        this.programTypeId = Number.parseInt(event.target.value);

    }

    private commercialAlert(): boolean {
        if (this.commercial.isCustomerCommercial) {
            let dialogRef = this.dialog.open(ResultDialogComponent, {
                data: {
                    message: "Please contact customer service to change your currency",
                    alertType: 'warning',
                    title: 'Updated Currency'
                }
            });
            return true;
        }
        else {
            return false;
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/change-currency/change-currency.component.ts